import { storage_keys } from '@/constant/configs';
import { useUserStore } from '@/stores/customer/user';
import { useEffect, useState } from 'react';
import { removeCustomerAuthCreds } from '@/lib/utils/functions';
import { deleteFCMToken } from '@/lib/utils/fcm-cleanup';

export default function useAuth() {
  const [isCustomerLoggedIn, setIsCustomerLoggedIn] = useState<boolean>(false);
  const [isBusinessLoggedIn, setIsBusinessLoggedIn] = useState<boolean>(false);
  const [isAnyUserLoggedIn, setIsAnyUserLoggedIn] = useState<boolean>(false);
  const removeUser = useUserStore((state) => state.removeUser);

  const customerToken =
    typeof window === 'undefined'
      ? null
      : window.localStorage.getItem(storage_keys.customer_token);

  const businessToken =
    typeof window === 'undefined'
      ? null
      : window.localStorage.getItem(storage_keys.restaurant_token);

  useEffect(() => {
    if (customerToken) {
      setIsCustomerLoggedIn(true);
      setIsAnyUserLoggedIn(true);
    }
    if (businessToken) {
      setIsBusinessLoggedIn(true);
      setIsAnyUserLoggedIn(true);
    }
  }, [customerToken, businessToken]);

  const logOut = async (cb?: () => void) => {
    await deleteFCMToken();
    removeCustomerAuthCreds();
    localStorage.removeItem('4TA_CART');
    removeUser();
    if (cb) {
      cb();
    }
    window.location.href = '/';
  };

  return { isCustomerLoggedIn, isBusinessLoggedIn, isAnyUserLoggedIn, logOut };
}
